import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProjectActivityResourcesGanttView } from "src/components/views/erp/project/gantt/ProjectActivityResourcesGanttView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/project/resourcesGantt")({
	staticData: { title: i18n.t("resources_gantt"), legacyViewKey: "projectActivityResourcesGanttPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ProjectActivityResourcesGanttView />;
}
